umpApp.initSite = {
    init: function () {

        setTimeout(function () {
            $("#toggle-ump").css({ "opacity": "1" });
            $("#select-lang").css({ "opacity": "1" });
        }, 1000);

        // //menu burger
        // console.log('$("#toggle-ump"): ', $("#toggle-ump"));
        // $("#toggle-ump").click(function () {
        //     console.log('click: ');

        //     $(this).toggleClass("on");
        // });

        umpApp.initSite.initParallax();

        // var url = location.href;               //Save down the URL without hash.
        // location.href = "/ump-local/home/#page-contact";                 //Go to the target element.
        // history.replaceState(null, null, url);   //Don't like hashes. Changing it back.

    },
    initParallax: function () {
        //parallax
        umpApp.heightSite = $("#page-accueil").height() * 4;

        // var windowHeight = $(window).height();
        // $("#page-accueil").css('min-height', windowHeight);
        // $("#page-entreprise").css('min-height', windowHeight);
        // $("#page-realisation").css('min-height', windowHeight);
        // $("#page-contact").css('min-height', windowHeight);

        umpApp.heightPage = umpApp.heightSite / 4;
        umpApp.initSite.Parallax($("#full-width-page-wrapper"));
        $("#full-width-page-wrapper").scroll(function (e) {
            umpApp.initSite.Parallax($("#full-width-page-wrapper"));
        });

        $('body').bind('touchmove', function (e) {
            umpApp.initSite.Parallax($('body'));
        });
    },
    Parallax: function (ele) {
        var friction = 5;
        var posYScroll = $(ele).scrollTop();
        console.log('posYScroll: ', posYScroll);
        var posYBg = 0;
        //console.log('posYScroll: ', posYScroll);
        if (posYScroll < umpApp.heightPage) {
            posYBg = posYScroll / friction;
            $("#page-accueil").css({
                "background-position-y": "-" + posYBg + "px",
            });
        }
        if (posYScroll < (umpApp.heightPage * 2)) {
            posYBg = (posYScroll - (umpApp.heightPage)) / friction;
            $("#page-entreprise").css({
                "background-position-y": "-" + posYBg + "px",
            });
        }
        if (posYScroll > umpApp.heightPage && posYScroll < umpApp.heightPage + (umpApp.heightPage * 3)) {
            posYBg = (posYScroll - (umpApp.heightPage * 2)) / friction;
            $("#page-realisation").css({
                "background-position-y": "-" + posYBg + "px",
            });
        }
        if (posYScroll > (umpApp.heightPage * 2) && posYScroll < umpApp.heightPage + (umpApp.heightPage * 4)) {
            posYBg = (posYScroll - (umpApp.heightPage * 3)) / friction;
            $("#page-contact").css({
                "background-position-y": "-" + posYBg + "px",
            });
        }
    }
};